import axios from 'axios';
import router from '../router'
import { Message } from 'element-ui';
import cookie from './cookie.js';
import store from '../store'
import Vue from 'vue'
import { saveAs } from 'file-saver'


//1.系统未登录之前的请求
const status = {
	400: '请求出现错误',
	401: '没有提供登录认证信息',
	403: '没有权限',
	404: '请求内容不存在',
	405: '请求方式错误',
	406: '请求的资源并不符合要求',
	408: '客户端请求超时',
	413: '请求体过大',
	415: '类型不正确',
	416: '请求的区间无效',
	500: '服务器错误',
	501: '请求还没有被实现',
	502: '网关错误',
	503: '服务暂时不可用',
	504: '服务连接失败',
	505: '请求的 HTTP 版本不支持',
};
// 创建axios实例

const service = axios.create({
});

// request拦截器
service.interceptors.request.use(
	(config) => {
		let userToken = cookie.get('PIE_MALL_Token');
		let cpeosToken = cookie.get('CPEOS_Token');
		config.headers['language'] = localStorage.getItem('change-language');
		if (userToken) {
			config.headers['Authorization'] = userToken;
			// config.headers['token'] = cpeosToken;
			config.headers['Cpeostoken'] = cpeosToken;
		} else {
			config.withCredentials = true;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

// response 拦截器
service.interceptors.response.use(
	(res) => {
		return res;
	},
	(error) => {
		console.log('接口error', error.response.status, router);
		if (error.response.status === 401) {
			// 401表示没有登录
			// 提示没有登录
			cookie.set('PIE_MALL_Token', '')
			cookie.set('CPEOS_Token', '')
			// store.dispatch("user/loginOut", {});

			// location.href='https://www.cpeos.org.cn/personal/login/business?url='+window.location.href;
			location.href = window.dataManage.tianhuiLoginUrl + '?url=' + window.location.href;


			// router.beforeEach((to, from, next) => {
			//   console.log(to, from, next);
			//   if (to.meta.requireAuth) {
			//     Vue.prototype.notifyError('登录过期，请重新登录！');
			//     next({path: `/login?redirect=${to.fullPath}`});
			//   }
			// })
		}
		if (error.response.status === 500) {
			// 500表示服务器异常
			// 跳转error页面
			router.push({ path: "/error" });
		}
		// Message.error(status[error.response.status]);
		// return Promise.reject(error);
	}
);
export default {
	//get请求
	get (url, params = {}, tag = false) {
		delete params._rowKey;
		delete params._index;
		return new Promise((resolve, reject) => {
			service({
				method: 'get',
				url,
				params: params,
			})
				.then((res) => {
					if (tag) {
						resolve(res.data);
						return;
					}
					if (res && res.data.code === 200) {
						resolve(res.data);
					} else {
						Message.error(res.data.msg || '错误');
						// reject(res.data);
					}
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	//post请求
	post (url, params = {}) {
		delete params._rowKey;
		delete params._index;
		return new Promise((resolve, reject) => {
			service({
				method: 'post',
				url,
				data: params
			})
				.then((res) => {
					if (res && res.data.code === 200) {
						resolve(res.data);
					} else {
						Message.error(res.data.msg || '错误');
						// reject(res.data);
					}
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	//put请求
	put (url, params = {}) {
		delete params._rowKey;
		delete params._index;
		return new Promise((resolve, reject) => {
			service({
				method: 'put',
				url,
				data: params,
			})
				.then((res) => {
					if (res && res.data.code === 200) {
						resolve(res.data);
					} else {
						Message.error(res.data.msg || '错误');
						// reject(res.data);
						// reject(res.data);
					}
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	//delete请求
	delete (url, params = {}) {
		delete params._rowKey;
		delete params._index;
		return new Promise((resolve, reject) => {
			service({
				method: 'delete',
				url,
				data: params,
			})
				.then((res) => {
					if (res && res.data.code === 200) {
						resolve(res.data);
					} else {
						Message.error(res.data.msg || '错误');
						// reject(res.data);
					}
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	//form请求
	form (url, params = {}, type = 'post') {
		delete params._rowKey;
		delete params._index;
		let formData = new FormData();
		let keys = Object.keys(params);
		keys.map((v) => {
			if (Array.isArray(params[v])) {
				params[v].map((w) => {
					formData.append(v, w);
				});
			} else {
				formData.append(v, params[v]);
			}
		});
		return new Promise((resolve, reject) => {
			service({
				method: type,
				url,
				headers: { 'Content-Type': 'multipart/form-data' },
				data: formData,
			})
				.then((res) => {
					if (res && res.data.code === 200) {
						resolve(res.data);
					} else {
						Message.error(res.data.msg || '错误');
						reject(res.data);
					}
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	//download请求
	download (url, params = {}) {
		delete params._rowKey;
		delete params._index;
		return new Promise((resolve, reject) => {
			service({
				method: 'get',
				url,
				params: params,
				responseType: 'blob',
			})
				.then((res) => {
					if (res) {
						const blob = new Blob([res.data])
						saveAs(blob, params.fileName)
					} else {
						Message.error(res.data.msg || '错误');
						reject(res.data);
					}
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	// 上传大内容文件
	postFile (url, params = {}, uploadEvent = () => { }) {
		delete params._rowKey;
		delete params._index;
		return new Promise((resolve, reject) => {
			service({
				method: 'post',
				url,
				data: params,
				onUploadProgress: uploadEvent
			}).then((res) => {
				if (res && res.data.code === 200) {
					resolve(res.data);
				} else {
					Message.error(res.data.msg || '错误');
					// reject(res.data);
				}
			}).catch((error) => {
				reject(error);
			});
		});
	}
};